import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import jsSHA from "sha";
import "jquery-libs/jquery.validate";

"use strict";
function score_password(pass) {
        var score = 0;
        if (!pass)
            return score;
    
        // award every unique letter until 5 repetitions
        var letters = new Object();
        for (var i=0; i<pass.length; i++) {
            letters[pass[i]] = (letters[pass[i]] || 0) + 1;
            score += 5.0 / letters[pass[i]];
        }
    
        // bonus points for mixing it up
        var variations = {
            digits: /\d/.test(pass),
            lower: /[a-z]/.test(pass),
            upper: /[A-Z]/.test(pass),
            nonWords: /\W/.test(pass),
        }
    
        var variationCount = 0;
        for (var check in variations) {
            variationCount += (variations[check] == true) ? 1 : 0;
        }
        score += (variationCount - 1) * 10;
    
        return parseInt(score);
}


function password_strength(pass) {
    var score = score_password(pass);
    if (score > 120)
        return _("password_strength_very_strong", "very strong");
    if (score > 90)
        return _("password_strength_strong", "strong");
    if (score > 60)
        return _("password_strength_good", "good");
    if (score > 30)
        return _("password_strength_weak", "weak");
    if (score > 0)
        return _("password_strength_very_weak", "very weak");
    return "";
}

ko.bindingHandlers.checkpassword = {
    init:function(elt, va, bindings, model, context) {
        var $el = $(elt);
        var hash = ko.unwrap(va());
        var no_hash = ko.unwrap(bindings().nohash) === true, newvalue;
        
        var callback = function(){
            newvalue = $el.val();
            if (newvalue != null && newvalue != "") {
                var hash = newvalue;
                if (!no_hash) {
                    var shaObj = new jsSHA(newvalue, "ASCII");
                    hash = shaObj.getHash("HEX");
                }
                va()(hash);
            }
            else va()("");
        }
        $el.val("").change(callback).blur(callback)
    }
};

$.validator.addMethod("passwordrepeat", function passwordrepeat(value, element, param) {
    var model = $(element).closest(".ulypassword").data("ulypassword");
    if (!model) {
        return true;
    }
    if (!model.password() && !model.password_repeat()) {
        return true;
    }
    return model.is_consistent();
}, _("password_validator_repeat_failed", "Please ensure both passwords are the same"));

$.validator.addMethod("mincomplexity", function mincomplexity( value, element, param ) {
    var model = $(element).closest(".ulypassword").data("ulypassword");
    if (!model) {
        return true;
    }
    if (!model.password() && !model.password_repeat()) {
        return true;
    }
    return model.is_strong();
}, _("password_validator_min_complexity", "Please enter a stronger password"));

ko.bindingHandlers.password = {
    init:function(elt, va, bindings, model, context) {
        var $el = $(elt);
        var $form_container = $el.closest(".form-group");
        var observable = va();
        var new_model = {
            "password": ko.observable(null),
            "password_repeat": ko.observable(null),
        }
        new_model.score = ko.pureComputed(function() {
            return score_password(new_model.password())
        });
        new_model.strength = ko.pureComputed(function() {
            return password_strength(new_model.password())
        });
        new_model.is_strong = ko.pureComputed(function() {
            return new_model.score() > 60;
        });
        new_model.is_consistent = ko.pureComputed(function() {
            return new_model.password() === new_model.password_repeat();
        });
        new_model.is_valid = ko.pureComputed(function() {
            return new_model.is_consistent() && new_model.is_strong();
        });
        new_model.score_percent = ko.pureComputed(function(){
            var score = new_model.score();
            return "{0}%".format(parseInt((score > 150 ? 150 : score) / 1.5));
        });
        new_model.colour = ko.pureComputed(function() {
            var score = new_model.score();
            if (score > 120) {
                return "success"
            } else if (score > 90) {
                return "java"
            } else if (score > 60 ) {
                return "starship"
            } else if (score > 30) {
                return "warning"
            } else return "danger";
        })
        var new_password = ko.pureComputed(function() {
            if (new_model.is_valid()) {
                return new_model.password();
            }
        });
        var passwordSetter = ko.computed(function() {
            if (new_password() && new_password() != observable.peek()) {
                observable(new_password());
            }
        });
        var sub = new_model.is_valid.subscribe(function(new_value) {
            console.log("is_valid:", new_value);
            if (new_value) {
                $form_container.removeClass("has-error").removeClass("has-warning").addClass("has-success");
            } else {
                $form_container.removeClass("has-error").removeClass("has-success").addClass("has-warning");
            }
            //observable(new_model.password());
        });
        ko.utils.domNodeDisposal.addDisposeCallback(elt, function() {
            sub.dispose();
            sub = null;
        });
        $el.data("ulypassword", new_model);

        ko.applyBindingsToDescendants(context.createChildContext(new_model), elt);
        
        return { "controlsDescendantBindings": true };
    }
};
